import { resolveFeatureFlag } from "../hooks/useFeatureFlag.js";
import { useAuthSession } from "../hooks/useWorkspaceRole.js";
import { PersonalAccessTokensView } from "../pages/PersonalAccessTokensView.js";
import { ColourSchemeField } from "./ColourSchemeField.js";
import { DeleteAccountSection } from "./DeleteAccountSection.js";
import { SkillsRepoSection } from "./SkillsRepoSection.js";
import { YagniCodeDevices } from "./YagniCodeDevices.js";

/**
 * Settings, the You card (`/settings/you`): everything that follows the
 * person rather than the workspace. YAGNI Code on this person's machines (the
 * install, the `yagni login` device code, and for admins every connected
 * device), the personal access tokens coding agents use over MCP, this
 * person's own skills repository for cloud runs, this device's colour scheme,
 * and the request to delete their account. `yagni login` sends people here
 * (the backend's device-flow verification URL; the old `/settings/tokens`
 * address redirects).
 */
export function YouView() {
  const session = useAuthSession();
  // No session is a standalone mount (tests); the backend refuses a login the
  // flag would refuse either way.
  const showInstall = session ? resolveFeatureFlag(session, "yagni_code.enabled") : true;
  return (
    <div className="body" data-testid="settings-you">
      <YagniCodeDevices showInstall={showInstall} />
      <PersonalAccessTokensView />
      <SkillsRepoSection />
      <ColourSchemeField />
      <DeleteAccountSection />
    </div>
  );
}
